import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import useValidationText from "../hooks/useValidationText";
import useValidationPhone from "../hooks/useValidationPhone";
import ApiData from "../api/ApiData";
import { observer } from "mobx-react-lite";
import { InputEditVer1 } from "../components/UI/InputEditVer1";
import Memory from "../api/Memory";
import { ListOptionRole } from "../components/employees/ListOptionRole";
import Loader from "../components/Loader";
import RolesState from "../api/RolesState";
import { ReqItem } from "../components/UI/ReqItem";
import { BtnOutlineV4 } from "../components/UI/button/BtnOutlineV4";
import { BtnPrimaryv4 } from "../components/UI/button/BtnPrimaryv4";
import { SiteModalHeader } from "../components/UI/SiteModalHeader";
import { SiteFormField } from "../components/UI/SiteFormField";
import { SiteModalToolbarBtn } from "../components/company/SiteModalToolbarBtn";
import { CcV4Toggle } from "../components/UI/CcV4Toggle";
import User from "../api/User";
import Msg from "../api/Msg";

const formatEmployeeName = (employee) => {
  const name = [employee.last_name, employee.first_name, employee.father_name]
    .filter((part) => part != null && String(part).trim() !== "")
    .join(" ");
  return name || "—";
};

const EmploessCard = observer(() => {
  const { id } = useParams();
  const [edit, setEdit] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [phone, setPhone] = useState("");

  const validPhone = useValidationPhone(phone);
  const validFirstName = useValidationText(firstName);
  const validLastName = useValidationText(lastName);
  const validFatherName = useValidationText(fatherName);

  useEffect(() => {
    Memory.funcSelectDayPeriodFlag(false);
    ApiData.setParameters("employee", null);
    ApiData.getPersone(`user/${id}`);
  }, [id]);

  const showEditor = () => {
    setEdit((prev) => !prev);
  };

  const editPersone = () => {
    const dataPersone = {};
    if (firstName !== "") {
      dataPersone.first_name = firstName;
    }
    if (lastName !== "") {
      dataPersone.last_name = lastName;
    }
    if (fatherName !== "") {
      dataPersone.father_name = fatherName;
    }
    if (phone !== "") {
      dataPersone.phone = phone;
    }
    ApiData.editPerson(dataPersone);
    setEdit(false);
  };

  const onEmployeeActiveClick = User.user.is_superuser
    ? async () => {
        const employee = ApiData.employee;
        if (!employee?.id) {
          return;
        }
        const nextActive = !employee.is_active;
        await User.setActiveUser(nextActive, employee.id);
        await ApiData.getPersone(`user/${id}`);
      }
    : () =>
        Msg.writeMessages("У вас нет прав для изменения активности сотрудника");

  if (!RolesState.emploee_id) {
    return <Navigate to="/noright" />;
  }

  return (
    <div className="main-page company-card-v4">
      {ApiData.employee !== null ? (
        <>
          {edit ? (
            <section
              className="card dash-card company-edit-panel"
              aria-labelledby="employee-edit-title"
            >
              <SiteModalHeader
                title="Редактирование сотрудника"
                titleId="employee-edit-title"
                toolbarWrap={false}
                toolbar={
                  <SiteModalToolbarBtn
                    variant="close"
                    onClick={showEditor}
                    title="Отменить редактирование"
                  />
                }
              />

              <div className="company-edit-meta">
                <div className="company-edit-inn-row">
                  <span className="site-form-label">Email</span>
                  <span className="company-edit-inn-value company-card-v4-mono">
                    {ApiData.employee.email}
                  </span>
                </div>
              </div>

              <div className="company-edit-grid">
                <SiteFormField label="Фамилия">
                  <InputEditVer1
                    className="site-form-control"
                    placeholder={ApiData.employee.last_name}
                    value={validLastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </SiteFormField>

                <SiteFormField label="Имя">
                  <InputEditVer1
                    className="site-form-control"
                    placeholder={ApiData.employee.first_name}
                    value={validFirstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </SiteFormField>

                <SiteFormField label="Отчество">
                  <InputEditVer1
                    className="site-form-control"
                    placeholder={ApiData.employee.father_name}
                    value={validFatherName}
                    onChange={(e) => setFatherName(e.target.value)}
                  />
                </SiteFormField>

                <SiteFormField label="Телефон" full>
                  <InputEditVer1
                    className="site-form-control"
                    placeholder={ApiData.employee.phone}
                    value={validPhone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </SiteFormField>

                {User.user.is_superuser ? (
                  <SiteFormField label="Роль" full>
                    <ListOptionRole />
                  </SiteFormField>
                ) : (
                  <ReqItem
                    label="Роль"
                    value={
                      ApiData.employee.role_rel !== null
                        ? ApiData.employee.role_rel.role_name
                        : "Не выбрана"
                    }
                    muted={ApiData.employee.role_rel === null}
                  />
                )}
              </div>

              {User.user.is_superuser || RolesState.admin_panel ? (
                <CcV4Toggle
                  label="Активен"
                  active={ApiData.employee.is_active}
                  onClick={onEmployeeActiveClick}
                />
              ) : null}

              <footer className="site-modal-footer employee-edit-footer">
                <BtnPrimaryv4
                  onClick={editPersone}
                  text="Сохранить изменения"
                  footerSize
                />
                <BtnOutlineV4 onClick={showEditor} text="Отмена" />
                {RolesState.reset_password ? (
                  <BtnOutlineV4
                    onClick={() => ApiData.resetPass()}
                    text="Сбросить пароль"
                    className="employee-reset-password-btn"
                  />
                ) : null}
              </footer>
            </section>
          ) : (
            <header className="card header-card">
              <div className="header-top">
                <div className="company-title">
                  <div className="compamy-title-name-container">
                    <span className="req-label">Сотрудник</span>
                    <h1>{formatEmployeeName(ApiData.employee)}</h1>
                  </div>
                </div>
                {RolesState.update_user ? (
                  <BtnOutlineV4 onClick={showEditor} text="Редактировать" />
                ) : null}
              </div>

              <div className="requisites-grid">
                <ReqItem
                  label="Email"
                  value={ApiData.employee.email || "—"}
                  mono
                />
                <ReqItem
                  label="Телефон"
                  value={ApiData.employee.phone || "—"}
                  mono
                />
                <ReqItem
                  label="Роль"
                  value={
                    ApiData.employee.role_rel !== null
                      ? ApiData.employee.role_rel.role_name
                      : "Не выбрана"
                  }
                  muted={ApiData.employee.role_rel === null}
                />
              </div>
            </header>
          )}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
});

export { EmploessCard };
